import React from "react";

import CustomerFullNameCellContent from "../components/CustomerFullNameCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function customerFullName({ width, onResize }: Column.Options) {
	return base(
		ColumnId.CustomerFullName,
		(item) => <CustomerFullNameCellContent item={item} />,
		{
			width,
			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default customerFullName;
